import { render, staticRenderFns } from "./ForecastingChart.vue?vue&type=template&id=c39bc4c2&scoped=true"
import script from "./ForecastingChart.vue?vue&type=script&lang=js"
export * from "./ForecastingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39bc4c2",
  null
  
)

export default component.exports